// @ts-nocheck
import React, { useState } from 'react';
import Select from 'antd/lib/select';
import Modal from '../../../components/ant/Modal';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { DatePicker } from '../../../components/ant/DatePicker';
import moment from 'moment';
import { applyMaskToValue } from '../../../lib/helpers';
import { formatLicensePlateMask } from '../../../components/inputs/masked-inputs/LicensePlateInput';
import { Form } from '../../../components';
import { Grid } from '../../../components/layout';
import { GridItem } from '../../../components/layout/Grid';
const {
  Option
} = Select;
export default props => {
  const {
    visible,
    onCancel,
    onSubmit,
    licensePlates,
    bioTreatmentFacilityFact = {}
  } = props;
  return <Modal destroyOnHidden width={800} title="Форма внесения факта" visible={visible} onCancel={onCancel} footer={[<Button key="back" onClick={onCancel}>
          Отмена
        </Button>, <Button key="submit" type="primary" form="modal-form" htmlType="submit">
          Добавить
        </Button>]}>
      <Form initialValues={bioTreatmentFacilityFact} onSubmit={onSubmit}>
        {(FormField, formikProps) => {
        const {
          setFieldValue,
          handleSubmit,
          values
        } = formikProps;
        return <form onSubmit={handleSubmit} id="modal-form">
              <Grid gutter="16px">
                <GridItem>
                  <FormField label="Дата" fast name="date" required>
                    {({
                  name,
                  value
                }) => <DatePicker name={name} showTime={{
                  format: 'HH:mm'
                }} value={value ? moment.utc(value) : value} format="DD MMMM YYYY HH:mm" onChange={value => {
                  setFieldValue(name, moment(value).toISOString());
                }} />}
                  </FormField>
                </GridItem>

                <GridItem>
                  <FormField label="Гос.номер" fast name="licensePlate" required>
                    {({
                  name,
                  value
                }) => <Select onChange={licensePlate => {
                  setFieldValue(name, licensePlate);
                }} allowClear defaultValue={values.licensePlate}>
                        {licensePlates.map(licensePlate => <Option value={licensePlate}>
                            {applyMaskToValue(licensePlate, formatLicensePlateMask)}
                          </Option>)}
                      </Select>}
                  </FormField>
                </GridItem>
              </Grid>
            </form>;
      }}
      </Form>
    </Modal>;
};
